<div
  [class]="
    'flex flex-col gap-(--infostatscard-gap) rounded-(--infostatscard-border-radius) bg-(--infostatscard-background) px-(--infostatscard-padding-x) py-(--infostatscard-padding-y) ' +
    (config().shadow ? 'shadow-(--infostatscard-shadow) ' : '')
  "
>
  <div class="flex flex-col gap-4">
    @if (showIcon() && config().icon) {
      <app-dynamic
        componentName="SvgIcon"
        [props]="{ name: config().icon, size: '32', color: 'var(--infostatscard-icon-color)' }"
      />
    }
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: titleTextConfig() }"
    />
  </div>

  @for (item of itemConfigs(); track $index) {
    <div class="flex flex-col items-start gap-2">
      <app-dynamic
        componentName="Chip"
        [props]="{ config: item.chipConfig }"
      />
      <div class="flex items-center gap-2">
        @if (item.icon) {
          <app-dynamic
            componentName="SvgIcon"
            [props]="{ name: item.icon, size: '24', color: 'var(--infostatscard-icon-color)' }"
          />
        }
        <app-dynamic
          componentName="DynamicText"
          [props]="{ config: item.valueTextConfig }"
        />
      </div>
    </div>
  }
</div>
